module.exports = __webpack_public_path__ + "static/img/bg-best-cinematography.45b309f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-best-cinematography.jpg
// module id = 182
// module chunks = 0